<template >
<el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="'top'" v-loading="loading">
  {{data_wizard1.limit}}
    <!--Parque-->
    <label class="font-size-sm mb-1">Parque seleccionado</label>
    <div class="w-100 form-control mb-3" v-text="ruleForm.seat_name"> </div>

    <!--espacio-->
    <label class="font-size-sm mb-1">Espacio seleccionado</label>
    <div class="w-100 form-control mb-3">{{product.title + ' - ' + ruleForm.schedul_name}} </div>

    <!--Fecha seleccionada-->
    <label class="font-size-sm mb-1">Fecha seleccionada</label>
    <div class="w-100 form-control mb-3">{{ruleForm.date_booking | moment("LL")}}</div>

    <!--<div class="row mb-3">
      <div class="col-sm-6">
          <el-form-item prop="actived" class="mb-0">
              <el-checkbox v-model="corporative.actived" @change="PricesProducts">Soy usuario corporativo</el-checkbox>
          </el-form-item>
      </div>
      <div class="col-sm-6" v-if="corporative.actived">
          <el-select v-model="corporative.opd" placeholder="seleccionar su área de trabajo" filterable class="w-100">
              <el-option v-for="item in opds" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
      </div>
    </div>-->


    <table class="table table-bordered">
        <colgroup>
            <col class="col-md-6">
            <col class="col-md-3">
            <col class="col-md-3">
        </colgroup>
        <tr class="bg-gray-100 text-center">
            <th scope="col" class="align-middle">Tipo de entrada</th>
            <th scope="col">Precio</th>
            <th scope="col">Cantidad</th>
        </tr>
        <tbody>
            <tr v-for="(domain, index) in listPrices" :key="index">
                <td class="align-middle font-size-sm">{{domain.name}}</td>
                <td class="font-weight-bolder align-middle">S/. {{domain.price}}</td>
                <td>
                  <div class="d-flex">
                      <div class="btn btn-sm rounded-circle btn-warning font-weight-bolder" @click.prevent="back(domain)" style="font-size: 1rem;width: 32px;">-</div>
                      <span class="mx-2 border px-3 pt-1">{{domain.quantity}}</span>
                      <div class="btn btn-sm rounded-circle btn-warning font-weight-bolder"  @click.prevent="next(domain)" style="font-size: 1rem;width: 32px;">+</div>
                  </div>
                </td>
            </tr>

        </tbody>

    </table>
    <label class="font-size-sm mb-1">Importe total a pagar</label>
     <h2 class="text-primary">S/ {{total}}</h2>


    <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm">Siguiente</button>
</el-form>
</template>

<script>
import moment from 'moment';

import prices from "@/services/prices.service"

export default {
    props: {
        product: {
            type: Object,
            required: true,
            default: {}
        },
        data_wizard1: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data: () => ({
        loading: false,
        ruleForm: {},
        rules: {},
        listPrices: [],
        limit: 0,

    }),
    computed:{
        total: function() {
            let importe = 0
            this.listPrices.forEach(element => importe += (parseInt(element.quantity) * element.price))
            return importe.toFixed(2)
        }
    },
    methods: {
        async PricesProducts() {
            //this.$emit("update:loading", true)
            this.loading = true

            await prices.get({a:this.product.idproduct}).then((response) => {
                this.listPrices = response.data
                /*if(this.corporative.actived){
                    this.opds = response.data.opds
                    this.$alert(response.data.message, 'IMPORTANTE')
                    //alert(response.data.message)
                }
                console.log(response.data)*/
                //this.$emit("update:loading", false)
                this.loading = false
            }).catch((error) => {
                alert('Lo sentimos, nuestra plataforma esta presentando inconvenientes, intentalo más tarde')
                //this.$emit("update:loading", false)
                this.loading = false
            }).finally(() => {
                this.loading = false
                //this.$emit("update:loading", false)
            })
        },

        back(row){
            this.listPrices.filter(param => (param.idprice == row.idprice && parseInt(param.quantity)>0) ? param.quantity =parseInt(param.quantity) - 1  : 0)

        },
        next(item){
          let cantidad = 1;
          this.listPrices.forEach((value,index ) => {


              //newData.push(value);

              if(value.qlimit =="1"){
                  //value.quantity = 8
                  //console.log(value.quantity)
                  cantidad += parseInt(value.quantity)
              }
            });
            //this.limit =
            //console.log("newData", cantidad);
            //console.log("lim", this.limit);
            if(this.limit>=cantidad){
              this.listPrices.filter(param => (param.idprice == item.idprice && parseInt(param.quantity)>=0) ? param.quantity =parseInt(param.quantity) + 1  : 0)
            }else{
              alert('Lo sentimos, la cantidad de entradas seleccionadas no puede superar el aforo permitido por grupo.')
            }



        },

        submitForm() {
            /*if(this.corporative.actived && this.corporative.opd == null ){
                this.$message.error('Oops, Falta seleccionar el lugar de trabajo');
                return false
            }*/
            if(this.total>0){
                this.$emit("update:number", 3)
                this.$emit("getWizard2",  this.listPrices )
            }

        }
    },
    created() {
        if (Object.keys(this.data_wizard1).length > 0) {
            this.ruleForm = this.data_wizard1;
            this.limit = parseInt(this.data_wizard1.limit)
            this.ruleForm.date_booking = moment(this.ruleForm.date_booking).format("YYYY-MM-DD")
        }

        this.PricesProducts()
        //console.log(Object.keys(this.data_wizard1).length);
    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/camping/wizard2.vue